<template>
<div class="bind-fail">
  <ucar-title>绑定车辆</ucar-title>
  <div class="bind-fail-body">
    <img src="../../assets/icon-fail.png">
    <h2>审核未通过</h2>
    <p>
      非常抱歉
      <br />
      您的车辆【{{vehicleNo}}】审核未通过
    </p>
    <section v-if="failReason && failReason.length > 0" class="bind-fail-reason-wrap">
      <div class="bind-fail-reason">
        <h3>未通过原因:</h3>
        <ul>
          <li v-for="item in failReason" :key="item">{{item}}</li>
        </ul>
      </div>
    </section>
  </div>
  <div class="bind-fail-footer">
    <ucar-button size="full" @click="reBind">重新绑定车辆</ucar-button>
  </div>
</div>  
</template>

<script>
export default {
  computed: {
    vehicleNo () {
      if (!this.vuexVehicleInfo || !this.vuexVehicleInfo.vehicleLicensePlateNo) return ''
      return `${this.vuexVehicleInfo.vehicleLicensePlateNo.slice(0, 2)} ${this.vuexVehicleInfo.vehicleLicensePlateNo.slice(2)}`
    },
    failReason () {
      if (!this.vuexVehicleInfo || !this.vuexVehicleInfo.failReason) return []
      return this.vuexVehicleInfo.failReason.split(';')
    }
  },
  methods: {
    reBind () {
      this.setVuexVehicleInfo(null)
      this.changeStatusToFillInfo()
      this.$router.push('/vehicle-info')
    }
  },
  mounted () {
    if (!this.vuexVehicleInfo) {
      this.$router.replace('/progress-info')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.bind-fail {
  background-color: #fff;

  .bind-fail-body {
    box-sizing: border-box;
    min-height: calc(100% - 240px);
    padding-top: 100px;
    display: flex;
    flex-flow: nowrap column;
    align-items: center;

    img {
      width: 88px;
      height: 88px;
    }

    h2 {
      font-size: $ucar_font_h3-5;
      line-height: 50px;
      height: 50px;
      margin: 40px 0;
      color: $ucar_font_color;
    }

    p {
      text-align: center;
      color: $ucar_font_assist_color;
      font-size: $ucar_font_h4;
      line-height: 44px;
      margin-bottom: 60px;
    }

    .bind-fail-reason-wrap {
      position: relative;
      flex-grow: 1;
      display: flex;
      flex-flow: nowrap column;
      align-items: center;
      width: 690px;
      padding-top: 10px;

      &::before {
        content: '';
        position: absolute;
        background: url('../../assets/fail-reason-header.png') no-repeat center top / 100% auto;
        top: 0;
        left: 0;
        right: 0;
        height: 20px;
      }

      .bind-fail-reason {
        box-sizing: border-box;
        position: relative;
        width: 650px;
        padding: 70px 60px;
        z-index: 2;
        flex-grow: 1;
        background-color: #f8f8f8;
        box-shadow: 0 4px 8px 0 #ddd;

        h3 {
          color: $ucar_font_color;
          text-align: center;
          font-size: $ucar_font_h3-5;
          line-height: 48px;
          margin-bottom: 40px;
        }
  
        ul {
          padding-left: 40px;
          li {
            list-style: disc outside;
            color: $ucar_font_color;
            font-size: $ucar_font_h4;
            line-height: 44px;
          }
        }
      }
    }
  }

  .bind-fail-footer {
    box-sizing: border-box;
    width: 100%;
    padding: 30px;
  }
}

</style>
